import axios from 'axios';
import {getBrowserLang} from './toos'
import {
    Notify
  } from 'vant'
axios.defaults.headers = {
    'Content-type': 'application/json;charset=UTF-8'
}
const http = axios.create({
    // timeout: 10000
    baseURL: process.env.VUE_APP_Server
})

http.interceptors.request.use((config) => {
    config.headers["Content-type"] = "application/json;charset=UTF-8";
    config.headers["lang"] = getBrowserLang();
    if (config.method === 'get' && config.params) {
        let url = config.url + '?';
        for (const propName of Object.keys(config.params)) {
          const value = config.params[propName];
          var part = encodeURIComponent(propName) + "=";
          if (value !== null && typeof(value) !== "undefined") {
            if (typeof value === 'object') {
              for (const key of Object.keys(value)) {
                let params = propName + '[' + key + ']';
                var subPart = encodeURIComponent(params) + "=";
                url += subPart + encodeURIComponent(value[key]) + "&";
              }
            } else {
              url += part + encodeURIComponent(value) + "&";
            }
          }
        }
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config;
},function (error) {
    return Promise.reject(error)
})

http.interceptors.response.use((response)=>{
    if (response.status === 200) {
        return Promise.resolve(response.data);
    } else {
        Notify({ type: 'danger', message: response.message });
        return Promise.reject(response.data);
    }
},function(error) {
    return Promise.reject(error)
})

export default http;
